import { UserHierarchyModel } from "../models/UserHierarchyModel";
import { client } from "./API";

const UserHierarchyService = {
  async getUserHierarchys() {
    const response = await client({
      url: "User/GetUserHierarchy",
      method: "get",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async createUserHierarchy(
    data: UserHierarchyModel
  ) {
    try {
      const response = await client({
        method: "post",
        url: "User/PostUserHierarchy",
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  async deleteUserHierarchy(
    data: UserHierarchyModel
  ) {
    try {
      const response = await client({
        method: "delete",
        url: "User/DeleteUserHierarchy",
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  async GetSbusFromSbgs(sbgName: string) {
    const response = await client({
      url: `User/GetSBUsBySBG/${sbgName}`,
      method: "get",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    })
    return response.data
  }
};
export default UserHierarchyService;
